module.exports = __webpack_public_path__ + "static/media/report5.8d3ee92f.png";